<div id="guidance-dialog" class="dialog-container">
  <div cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" class="dialog-header">
    <h4>{{ sectionTitle }}</h4>
    <button id="dialog-close" class="icon-close" (click)="close()"></button>
  </div>
  <div class="container">
    <div class="section-container editor-text" [innerHTML]="guidance"></div>
  </div>
</div>
